<script setup lang="ts">
import { computed } from "vue";
import UseSvg from "components/jiffy/vue-cart/UseSvg.vue";

const props = defineProps<{
  tier: "print_original" | "custom" | "full_enhancements" | "basic";
}>();

const icon = computed(() => {
  if (props.tier === "print_original") return "printer";
  if (props.tier === "custom") return "stars-4";
  if (props.tier === "full_enhancements") return "stars";
  if (props.tier === "basic") return "star-4";
  return "";
});

const label = computed(() => {
  if (props.tier === "print_original") return "Print As-is";
  if (props.tier === "custom") return "Expert Edit";
  if (props.tier === "full_enhancements") return "PrintPerfect";
  if (props.tier === "basic") return "Basic";
  return "";
});
</script>

<template>
  <div class="enhancement-tier-label">
    <UseSvg :icon="icon" class="enhancement-tier-label__icon" />
    {{ label }}
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";

.enhancement-tier-label {
  display: flex;
  align-items: center;
  border-radius: 4px;
  color: $primary-light;
  font-size: 12px;
  background: $enhance-gradient;
  height: 28px;
  padding: 0 10px;
  white-space: nowrap;
  position: relative;
  z-index: 0;

  &::before {
    border-radius: 2px;
    position: absolute;
    inset: 2px;
    margin: auto;
    z-index: -1;
    background: $white;
    content: "";
  }

  &__icon {
    width: 19px;
    height: 18px;
    margin-right: 6px;
  }
}
</style>
